<template>
  <path
    d="M12 19.0002C13.1 19.0002 14 18.1002 14 17.0002V16.0002H10V17.0002C10 18.1002 10.9 19.0002 12 19.0002ZM5 5.50024C5 6.33024 5.67 7.00024 6.5 7.00024H10V10.0002H14V7.00024H17.5C18.33 7.00024 19 6.33024 19 5.50024C19 4.67024 18.33 4.00024 17.5 4.00024H6.5C5.67 4.00024 5 4.67024 5 5.50024ZM4 14.0002H20C20.55 14.0002 21 13.5502 21 13.0002C21 12.4502 20.55 12.0002 20 12.0002H4C3.45 12.0002 3 12.4502 3 13.0002C3 13.5502 3.45 14.0002 4 14.0002Z"
  />
</template>
